import { Agent } from "../interfaces/agent.interface";
import { AgentListInfo } from "../services/agent.list.info";
import { AgentAuxStatus, getAgentAuxStatus } from "./agent";

export enum ViolationPopupSection {
    ScreenShot,
    ScreenRecord,
    CameraRecord,
    CameraPic,
    GeoLocation,
    AgreeDisagree,
}

export const isFeatureEnabled = (featureName: string, agentInfo: Agent | null): boolean => {
    let isFeatureEnabled: boolean = false;
    let isIndividualFeatureEnabled: boolean = false

    if (agentInfo != null) {
        //From OCM side, there are 2 ways of configuring features, either through templates OR through User onboarding
        //If the feature is configured via templates, then the feature will be applied to the entire team
        //If the feature is configured via UserOnboarding, then the feature will be applied individually to the user
        //AgentIndividualFeatures property gets its data from the Useronboarding module
        //AgentFeatures property gets its data from the Templates module
        //Always first check if the feature is enabled individually for that user in Useronboarding using AgentIndividualFeatures
        //If it is not present or set to false, then we check the Templates using AgentFeatures
        //The feature has to be present in either one or both the properties

        if (agentInfo.AgentIndividualFeatures != null) {
            if (agentInfo.AgentIndividualFeatures != null) {
                for (const featureInfo of agentInfo.AgentIndividualFeatures) {
                    if (featureInfo.Feature === featureName.trim()) {
                        if (featureInfo.Enable != null && featureInfo.Enable !== false) 
                            isIndividualFeatureEnabled = true;
                        break;
                    }
                }
            }
        }

        if (isIndividualFeatureEnabled === false) {
            if (agentInfo.AgentFeatures != null) {
                for (const featureInfo of agentInfo.AgentFeatures) {
                    if (featureInfo.Feature === featureName.trim()) {
                        if (featureInfo.Enable != null && featureInfo.Enable !== false)
                            isFeatureEnabled = true;
                        break;
                    }
                };
            }
        }
        else isFeatureEnabled = isIndividualFeatureEnabled;
    }

    return isFeatureEnabled;
}

export const isViolationPopupSectionEnabled = (lanId: string, section: ViolationPopupSection, agentListInfoService: AgentListInfo): boolean => {
    const agentInfo: Agent | null = agentListInfoService.GetAgentInfo(lanId);
    let _isFeatureEnabled: boolean = false;

    switch (section) {
        case ViolationPopupSection.ScreenShot:
            _isFeatureEnabled = isFeatureEnabled("TRS_SCREENSHOT_ENABLED", agentInfo) || isFeatureEnabled("IsTRSScreenShotEnabled", agentInfo) || isFeatureEnabled("IsTCIScreenShotEnabled", agentInfo);
            break;
        case ViolationPopupSection.ScreenRecord:
            _isFeatureEnabled = isFeatureEnabled("TRS_SCREENVIDEO_ENABLED", agentInfo) || isFeatureEnabled("IsTRSScreenVideoEnabled", agentInfo) || isFeatureEnabled("IsTCISScreenVideoEnabled", agentInfo);
            break;
        case ViolationPopupSection.CameraRecord:
            _isFeatureEnabled = isFeatureEnabled("TRS_CAMERAVIDEO_ENABLED", agentInfo);
            break;
        case ViolationPopupSection.CameraPic:
        case ViolationPopupSection.AgreeDisagree:
            //If campic is disabled, dont show the agree/disagree button
            _isFeatureEnabled = isFeatureEnabled("TRS_CAMERAPICTURE_ENABLED", agentInfo) || isFeatureEnabled("IsTRSCameraPictureEnabled", agentInfo) || isFeatureEnabled("IsTCISCameraPictureEnabled", agentInfo);
            break;
        case ViolationPopupSection.GeoLocation:
            _isFeatureEnabled = isFeatureEnabled("TRS_GEOLOCATION_ENABLED", agentInfo) || isFeatureEnabled("IsTRSGeoLocationEnabled", agentInfo) || isFeatureEnabled("IsTCISGeoLocationEnabled", agentInfo);
            break;
    }

    return _isFeatureEnabled;
}

export const isSupervisorChatEnabled = (lanId: string, agentListInfoService: AgentListInfo) => {
    const agentInfo: Agent | null = agentListInfoService.GetAgentInfo(lanId);
    let isSupervisorChatEnabled: boolean = false;

    if (agentInfo != null) {
        const currentAuxCode: AgentAuxStatus = getAgentAuxStatus(agentInfo);

        if (currentAuxCode === "logged-out") 
            //If the agent is logged out, supervisor should not be able to send him a message
            isSupervisorChatEnabled = false;
        else isSupervisorChatEnabled = isFeatureEnabled("TRS_SUPERVISOR_CHAT_ENABLED", agentInfo);
    }

    return isSupervisorChatEnabled;
}

export const isPeepButtonEnabled = (lanId: string, agentListInfoService: AgentListInfo): boolean => {
    let isPeepButtonEnabled: boolean = false;
    const agentInfo: Agent | null = agentListInfoService.GetAgentInfo(lanId);

    if (agentInfo != null) {
        const currentAuxCode: AgentAuxStatus = getAgentAuxStatus(agentInfo);
        const peepBeforeLoginEnabled: boolean = isFeatureEnabled("TRS_PEEP_BEFORE_LOGIN_ENABLED", agentInfo);
        const peepEnabled: boolean = isFeatureEnabled("TRS_PEEP_ENABLED", agentInfo);

        //Now based on the status of the agent we perform some functionality
        if (currentAuxCode === "available") {
            //During available state depending on the features TRS_PEEP_BEFORE_LOGIN_ENABLED and TRS_PEEP_ENABLED we enable the block button
            if (peepBeforeLoginEnabled !== false && peepEnabled !== false) 
                isPeepButtonEnabled = true;
            else isPeepButtonEnabled = false;
            
            // if (peepBeforeLoginEnabled === false && peepEnabled === false) 
            //     isPeepButtonEnabled = false;
            // else if (peepBeforeLoginEnabled !== false && peepEnabled !== false) 
            //     isPeepButtonEnabled = true;
            // else if (peepBeforeLoginEnabled !== false && peepEnabled === false) 
            //     isPeepButtonEnabled = false;
            // else if (peepBeforeLoginEnabled === false && peepEnabled !== false) 
            //     isPeepButtonEnabled = false;
        }
        else if (currentAuxCode === "logged-out")
            //During logged out state there is no point in doing a peep
            isPeepButtonEnabled = false;
        else
            //During logged in state we have to enable the buttons
            isPeepButtonEnabled = peepEnabled;
    }

    return isPeepButtonEnabled;
}